import { render, staticRenderFns } from "./fetchUrlSon.vue?vue&type=template&id=7969ba10&"
import script from "./fetchUrlSon.vue?vue&type=script&lang=js&"
export * from "./fetchUrlSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports